import { Controller } from "@hotwired/stimulus";
import { initializeAccordion } from "../../shared";

export default class extends Controller {
  connect() {
    selectpicker.init();
    selectpicker.onSelect(".chosen-select", this.fetchPolicy.bind(this));
  }

  fetchPolicy(e) {
    const companyEmployeeId = e.params.data.id;

    if (companyEmployeeId) {
      const url = `/dashboard/control_center/company_employees/${companyEmployeeId}/policy/edit`;
      loader.show();
      $.ajax({
        type: "GET",
        url: url,
        dataType: "script",
      });
    }
  }
}
